import { useSnackbar } from 'notistack';
import { useState } from 'react';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
// @mui
import { alpha } from '@mui/material/styles';
import { Box, Divider, Typography, Stack, MenuItem } from '@mui/material';
// routes
import { PATH_DASHBOARD, PATH_AUTH ,ADMIN_PATH_DASHBOARD} from '../../../routes/paths';
// hooks
import useAuth from '../../../hooks/useAuth';
import useIsMountedRef from '../../../hooks/useIsMountedRef';
// components
import MyAvatar from '../../../components/MyAvatar';
import MenuPopover from '../../../components/MenuPopover';
import { IconButtonAnimate } from '../../../components/animate';
import {useSelector} from "../../../redux/store";
import {useDispatch} from "react-redux";
import { setTestToDo, setTestResults, setBrowseTests, setJobList, setQualifications, setProfile } from "../../../redux/slices/tutorial";
import { useT } from '@transifex/react';
import {REGISTER_ROLE_UUID, USER_ROLE_UUID} from 'src/constants/user-role-constants';

export default function AccountPopover() {
  const navigate = useNavigate();
  const reduxDispatch = useDispatch()
  const { googleSignOut } = useAuth();
  const {name, email, userRole, isAgencyUser} = useSelector((state) => state.user);
  const t = useT();
  const isMountedRef = useIsMountedRef();
  const { enqueueSnackbar } = useSnackbar();
  const [open, setOpen] = useState(null);
  const MENU_OPTIONS = [
    {
      label: t('Profile'),
      linkTo: userRole === USER_ROLE_UUID ? PATH_DASHBOARD.user.account : ADMIN_PATH_DASHBOARD.general.account,
    },
    ...userRole === USER_ROLE_UUID ?
    [{
      label: t('Replay Tour'),
      linkTo:  '/user/tests-to-do'

    }]:[],
  ];

  const handleOpen = (event) => {
    setOpen(event.currentTarget);
  };

  const resetTourState = () => {
    console.log("reset tour state")
    reduxDispatch(setTestToDo(false))
    reduxDispatch(setTestResults(false))
    reduxDispatch(setBrowseTests(false))
    reduxDispatch(setJobList(false))
    reduxDispatch(setQualifications(false))
    reduxDispatch(setProfile(false))
    let currentLocation = window.location.href
    if(currentLocation.indexOf("tests-to-do") != -1){
      setTimeout(()=>{
        window.location.reload(true)
      },1000)

    }
  }
  const handleClose = (replay) => {
    setOpen(null);
    if(replay) resetTourState();
  };

  const handleLogout = async () => {
    try {
      await googleSignOut();
      navigate(PATH_AUTH.login, { replace: true });

      if (isMountedRef.current) {
        handleClose();
      }
    } catch (error) {
      console.error(error);
      enqueueSnackbar('Unable to logout!', { variant: 'error' });
    }
  };

  return (
    <>
      <IconButtonAnimate
        onClick={handleOpen}
        sx={{
          p: 0,
          ...(open && {
            '&:before': {
              zIndex: 1,
              content: "''",
              width: '100%',
              height: '100%',
              borderRadius: '50%',
              position: 'absolute',
              bgcolor: (theme) => alpha(theme.palette.grey[900], 0.8),
            },
          }),
        }}
      >
        <MyAvatar />
      </IconButtonAnimate>

      <MenuPopover
        open={Boolean(open)}
        anchorEl={open}
        onClose={handleClose}
        sx={{
          p: 0,
          mt: 1.5,
          ml: 0.75,
          '& .MuiMenuItem-root': {
            typography: 'body2',
            borderRadius: 0.75,
          },
        }}
      >
        <Box sx={{ my: 1.5, px: 2.5 }}>
          {!isAgencyUser && <Typography variant="subtitle2" noWrap>
            {name}
          </Typography>}
          <Typography variant="body2" sx={{ color: 'text.secondary' }} noWrap>
            {email}
          </Typography>
        </Box>

        <Divider sx={{ borderStyle: 'dashed' }} />

        {userRole !== REGISTER_ROLE_UUID && <Stack sx={{p: 1}}>
          {MENU_OPTIONS.map((option) => (
              <MenuItem key={option.label} to={option.linkTo} component={RouterLink}
                        onClick={() => handleClose(option.label === "Replay Tour")}>
                {option.label}
              </MenuItem>
          ))}
        </Stack>}

        <Divider sx={{ borderStyle: 'dashed' }} />

        <MenuItem onClick={handleLogout} sx={{ m: 1 }}>
          {t("Logout")}
        </MenuItem>
      </MenuPopover>
    </>
  );
}
